import React from 'react'
import { Container } from 'react-bootstrap'
import ProductItem from '../ProductItem/ProductItem'
import TitleSectionComponent from '../TitleSectionComponent/TitleSectionComponent'
import './ProductSlider.css'
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { BsShopWindow } from 'react-icons/bs'
import { shuffle } from 'lodash';
import { useEffect,useState } from 'react'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
export default function ProductSlider() {
    const colors = ['#7443FF', '#69B721', '#5F0101', '#7345FB', '#83CD1A', '#34ebe1', '#c034eb'];
    const shuffledColors = shuffle(colors);
    const [product, setProduct] = useState([])
    useEffect(()=>{
        axiosConfig.get("api/Products/suggested").then((res) => {
            setProduct(res.data);
          })
    },[])
    return (
        <>
            <div className='product-slider'>
                <Container>
                    <TitleSectionComponent title='محصولات پیشنهادی ' icon={<BsShopWindow />} />
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            300: {
                                slidesPerView: 1.5,
                                spaceBetween: 20,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                            1400: {
                                slidesPerView: 4,
                                spaceBetween: 40,
                            }
                        }}
                        modules={[Pagination, Autoplay]}
                        className="mySwiper"
                    >
                        {
                          product?.map((product,index) => (
                                <SwiperSlide key={index}>
                                    <ProductItem  product={product.product} backgroundColor={shuffledColors[index]} />
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </Container>
            </div>
        </>


    )
}
